import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'hide-iframe',
  template: `<iframe [src]="clearURL()"></iframe>`,
  styles: [`
  iframe{
    border: none;
    widht: 0;
    height: 0;
  }
  `]
})
export class IframeComponent {

  @Input() src:string = null;

  constructor(
    private domSanitizer: DomSanitizer
  ) { }

  clearURL(){
    return this.domSanitizer.bypassSecurityTrustResourceUrl(this.src);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/iframe.component.ts